import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { UiLogoutIcon } from "@jti/brand-icons/ui-logout";
import { liveChat } from "@jti/fe-clients";
import { BrowserStorage, CasProfileApi, User } from "@jti/rest-api";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import styles from "./SignOut.module.scss";
export const SignOut = ({ label, onLogOut }) => {
    const onLogout = useCallback(async () => {
        const user = new User(new BrowserStorage());
        const { uuid } = user.getUser();
        dispatchTrackingEvent(TrackingEvents.TrackingLogoutSuccess, { user_id: uuid || "no id" });
        try {
            await CasProfileApi.init().logout();
        }
        catch (error) {
            console.error("Logout error:", error);
        }
        finally {
            user.clearUser();
            liveChat.onLogout();
            // LiveChat does not provide a way for us to know what happened with the request,
            // so we wait for 500ms and hope for the best 🤞
            setTimeout(() => {
                onLogOut();
            }, 500);
        }
    }, [onLogOut]);
    return (_jsxs("button", { className: styles.signoutButton, onClick: onLogout, children: [_jsx("span", { className: styles.signoutButtonText, children: label }), _jsx(UiLogoutIcon, { className: styles.icon })] }));
};
//# sourceMappingURL=SignOut.js.map